
function CreateSubject(props) {
    return (
        <div>This will be CreateSubject form</div>
    );
}

export default CreateSubject;
